import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';

import { Card, CardSection } from 'components/Card';
import Message from 'components/Message';
import Button from 'components/Button';

import { bem } from 'helpers/class-name';

import { intlMessageShape } from 'constants/propTypes';
import { ICONS } from 'constants/icons';

import './MissingDataFeedbackModal.scss';

const { block, element } = bem('missing-data-feedback-modal');

const MissingDataFeedbackModal = ({ icon, title, message, buttonText, onButtonClick, onCloseModal }) => {
  return (
    <Card className={block()}>
      <CardSection flush className={element('header')}>
        <div className={element('close-button')}>
          <button type="button" onClick={onCloseModal}>
            <Isvg src={ICONS.cross} />
          </button>
        </div>
      </CardSection>

      <div className={element('icon')}>
        <Isvg src={icon} />
      </div>
      <Message className={element('title')} message={title} as="h1" />
      <Message className={element('message')} message={message} as="p" />
      <Button type="button" onClick={onButtonClick}>
        <Message message={buttonText} />
      </Button>
    </Card>
  );
};

MissingDataFeedbackModal.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.shape(intlMessageShape),
  message: PropTypes.shape(intlMessageShape),
  buttonText: PropTypes.shape(intlMessageShape),
  onButtonClick: PropTypes.func.isRequired,
  onCloseModal: PropTypes.func.isRequired,
};

export default MissingDataFeedbackModal;
